module.exports = __webpack_public_path__ + "media/images/icons/instagram-edce535486f0ed542d619c36df94c512.png";